import React from 'react';
import WatchComponent from '../components/WatchReporte'

import { sendService } from '../../Services/service'

class AddReporte extends React.Component {
  state = {
    reports: this.props.indicador.reportes.map(r => { return { ...r, editText: false, editValue: false } })
  }

  handlerDobleClick = (key, id) => {
    this.setState({
      reports: this.state.reports.map(r => {
        if (r.id === id)
          return { ...r, [key]: !r[key] }
        return { ...r }
      })
    })
  }

  deactiveReport = id => {
    sendService(`/api/v1/piscc/deactivateReport/${id}`)
    this.setState({ reports: this.state.reports.filter(f => f.id !== id) })
    this.props.reload()
  }

  editReport = (id, key, value) => {
    console.log(id, key, value)
    sendService(`/api/v1/piscc/edit/${id}/${key}/${value}`).then(res => console.log('res', res))
    this.setState({
      reports: this.state.reports.map(f => {
        if (f.id !== id) return { ...f }
        return {
          ...f,
          [key]: value,
          editText: key === 'texto' ? false : f.editText,
          editValue: key === 'value' ? false : f.editValue
        }
      })
    })
    this.props.reload()
  }

  render() {
    return (
      <WatchComponent
        indicador={this.props.indicador}
        close={this.props.close}
        vectors={this.props.vectors}
        reports={this.state.reports}
        dobleClick={this.handlerDobleClick}
        editReport={this.editReport}
        deleteReport={this.deactiveReport}
      />
    )
  }
}

export default AddReporte;